import React from 'react';
import { motion } from 'framer-motion';

const Loader = ({ text = "Cargando momentos increíbles..." }) => {
    return (
        <div className="flex flex-col items-center justify-center p-10 w-full animate-pulse">
            <div className="flex items-center gap-3 mb-4">
                {[0, 1, 2].map((i) => (
                    <motion.div
                        key={i}
                        animate={{
                            scale: [1, 1.5, 1],
                            opacity: [0.3, 1, 0.3],
                        }}
                        transition={{
                            duration: 1,
                            repeat: Infinity,
                            delay: i * 0.2,
                            ease: "easeInOut",
                        }}
                        className="w-4 h-4 rounded-full bg-[#f8485e]"
                    />
                ))}
            </div>
            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="text-gray-400 font-medium text-sm tracking-widest uppercase text-center"
            >
                {text}
            </motion.p>
        </div>
    );
};

export default Loader;
